<template>
  <div class="job-title-selector">
    <h4
      v-if="name && !settings.noHeader"
      :class="{ 'text-danger': invalidFeedback }"
    >
      <b>{{name}}{{required ? '*' : ''}}</b>
    </h4>
    <p
      v-if="description && !settings.noHeader"
      :class="{ 'text-danger': invalidFeedback, 'text-muted': !invalidFeedback }"
    >
      {{description}}
    </p>
    <template v-if="!settings.browse || !isGroupped">
      <b-form-group :label="settings.noHeader ? name : (settings.noTitle || $root.isCXR ? null : 'Job Title')">
        <multiselect
          :value="value"
          @input="onInput($event)"
          :options="options && options.length ? options : (Array.isArray(taxonomyOptions) ? taxonomyOptions.map(el => el.name) : [])"
          :multiple="multiple"
          :show-labels="!isGroupped"
          :group-select="false"
          :group-values="isGroupped ? 'options' : null"
          :group-label="isGroupped ? 'text' : null"
          :loading="$apollo.queries.taxonomyOptions.loading"
          @search-change="onSearch"
          placeholder="Start typing a job title..."
          class="multiselect-rlnx"
        >
          <template v-slot:noResult>Job title not found, try something similar</template>
        </multiselect>
        <div v-if="invalidFeedback" class="text-danger">{{invalidFeedback}}</div>
      </b-form-group>
    </template>
    <template v-else>
      <b-form-group label="Department">
        <multiselect
          :value="department"
          @input="(($event) => { department = $event; $emit('input', null) })"
          :options="options"
          :multiple="multiple"
          :group-select="false"
          label="text"
          placeholder="Select a department"
          class="multiselect-rlnx"
        >
          <template v-slot:noResult>Department not found, try something similar</template>
        </multiselect>
      </b-form-group>
      <b-form-group v-if="department && Array.isArray(department.options)" label="Job Titles">
        <multiselect
          :value="value"
          @input="$emit('input', $event)"
          :options="department.options"
          :multiple="multiple"
          :group-select="false"
          placeholder="Select a department"
          class="multiselect-rlnx"
        >
          <template v-slot:noResult>Department not found, try something similar</template>
        </multiselect>
      </b-form-group>
    </template>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import SearchTaxonomyTitlesQuery from '@/graphql/queries/SearchTaxonomyTitles.gql';

export default {
  name: 'JobTitleSelector',
  components: {
    Multiselect
  },
  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    value: {
      default: () => null,
    },
    options: {
      type: Array,
      default: () => null,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    invalidFeedback: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fatalErr: null,
    err: null,
    department: null,
    searchTerm: '',
    searchTermTimeout: null,
  }),
  mounted() {
    const { settings, isGroupped, value, options } = this;
    if (settings && settings.browse && isGroupped && value && Array.isArray(options)) {
      this.department = this.options.find(el => el.options.includes(value));
    }
  },
  apollo: {
    taxonomyOptions: {
      query: SearchTaxonomyTitlesQuery,
      variables() {
        const { searchTerm } = this;
        return { searchTerm };
      },
      update: ({ company: { taxonomyTitles } }) => Array.isArray(taxonomyTitles) ? taxonomyTitles
        .reduce((out, { id, name, alternateNames }) => {
          if (!out.map(el => el.name).includes(name)) out.push({ id, name });
          if (Array.isArray(alternateNames)) {
            alternateNames.forEach(el => {
              if (!out.map(el => el.name).includes(el)) out.push({ id, name: el });
            });
          }
          return out;
        }, []).sort((a, b) => a.name.length - b.name.length) : [],
      skip() {
        return !this.searchTerm || this.searchTerm.length < 2 || Array.isArray(this.options);
      },
      fetchPolicy: 'network-only',
      error(err) {
        this.$log.error(err);
      },
    },
  },
  computed: {
    isGroupped() {
      const { options } = this;
      if (Array.isArray(options) && options.length) {
        return typeof options[0] === 'object';
      }
      return false;
    }
  },
  methods: {
    onSearch(val) {
      clearTimeout(this.searchTermTimeout);
      this.searchTermTimeout = setTimeout(() => {
        this.searchTerm = val;
      }, 500);
    },
    onInput(val) {
      const { taxonomyOptions } = this;
      this.$emit('input', val);
      const jobTitle = Array.isArray(taxonomyOptions) ? taxonomyOptions.find(el => el.name === val) : null;
      this.$emit('setJobTitleID', jobTitle ? jobTitle.id : null);
      const { isGroupped, options } = this;
      if (isGroupped) {
        const category = options.find(el => el.options.includes(val));
        this.$emit('setJobCategory', category ? category.text : null);
      }
    }
  }
};
</script>

<style lang="scss">
.job-title-selector {
  .multiselect-rlnx {
    .multiselect__tags {
      height: auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/profile/JobTitleSelector.vue